import { Button, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap";
import { Btn, H4, Image, LI, P, UL } from "../AbstractElements";
import { Link } from "react-router-dom";
import { dynamicImage } from "../Utils";
import { AlreadyLeaving, Register, YesLogout } from "../Utils/Constants";

const LogoutModal = ({logoutHandler,  modalOpen, toggle }: any) => {
  return (
    <div>
      <Modal isOpen={modalOpen} toggle={toggle}>
       
        <ModalBody>
          <div className="modal-toggle-wrapper">
            <UL className="modal-img simple-list">
              <LI>
                <Image src={dynamicImage(`gif/logout.gif`)} alt="logout" />
              </LI>
            </UL>
            <H4 className="pt-3 text-center">{AlreadyLeaving}</H4>
            <P className="text-center">
              {"Are you sure want to logout this dashboard?"}
            </P>
            
            <Btn color="dark"  className="d-flex m-auto" onClick={logoutHandler}>
              {YesLogout}
            </Btn>
          </div>
        </ModalBody>
        
      </Modal>


      <>
      </>
    </div>
  );
};

export default LogoutModal;
